<template>
    <el-empty description="404 页面走丢了" />
</template>